<template>
    <v-form class="px-2"
            v-model="valid"
            ref="form"
            lazy-validation
            @submit.prevent="">
        <v-row class="pt-3"   >
            <v-col cols="12" class="font-weight-bold text-center" style="color: #172B4D">
                {{ $t('login.recoverPassword') }}
            </v-col>

            <v-col class="pt-2 text-center" style="font-size: 13px">
                {{ $t('login.weHaveSentYouACode') }} {{ translatedContactMethod || $t('login.emailOrPhone') }}
            </v-col>

            <v-col cols="12" class="py-2">
                <v-text-field :placeholder="$t('login.receivedCode')"
                              v-model="code"
                              id="codigo"
                              solo
                              hide-details
                              @keyup.enter="submit()">
                </v-text-field>
            </v-col>

            <v-col cols="12" class="pb-2">
                <v-text-field :placeholder="$t('login.newPassword')"
                              v-model="password"
                              type="password"
                              id="clave"
                              solo
                              hide-details
                              @keyup.enter="submit()">
                </v-text-field>
            </v-col>

            <v-col cols="12" class="pb-2">
                <v-text-field :placeholder="$t('login.confirmNewPassword')"
                              v-model="rpassword"
                              type="password"
                              id="rclave"
                              solo
                              hide-details
                              @keyup.enter="submit()">
                </v-text-field>
            </v-col>

            <v-col cols="12" class="pt-3 text-center" >
                <v-btn class="mr-4"
                       color="#11CDEF"
                       dark
                       @click="submit()"
                       :loading="loading"
                       style="font-size: 16px">
                    {{ $t('login.recover') }}
                </v-btn>
                <v-btn @click="$emit('changeSection', 'keybeLogin')"
                       style="font-size: 16px">
                    {{ $t('login.goBack') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import notifications from '@/libs/notifications'
import validations from '@/libs/validations'
import { EventBus } from '../../eventBus'

export default {
  created () {
    EventBus.$on('SET_CONTACT_WAY', (event) => { this.contactMethod = event })
  },
  computed: {
    translatedContactMethod () {
      if (this.contactMethod === 'phone') return this.$t('login.phone')
      if (this.contactMethod === 'email') return this.$t('login.email')
      return ''
    }
  },
  data: () => ({
    contactMethod: '',
    valid: false,
    loading: false,
    code: '',
    password: '',
    rpassword: ''
  }),
  methods: {
    submit () {
      if (!validations.newPassword({
        code: this.code,
        password: this.password,
        rpassword: this.rpassword
      })) return

      this.loading = true
      this.$store.dispatch('resetPasswordValidation', { code: this.code, password: this.password })
        .then(() => {
          this.loading = false
          notifications.success(this.$t('login.passwordSuccessfullyChanged'))
          this.$emit('changeSection', 'keybeLogin')
        })
        .catch(error => {
          notifications.error(error.message)
          this.loading = false
        })
    }
  },
  props: ['token']
}
</script>

<style scoped>
    ::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
        box-shadow: 0 2px 4px rgba(23, 23, 23, 0.18);
        text-decoration: none!important;
    }
    ::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot input {
        border-bottom: none!important;
    }
</style>
